// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__7qpEf","search":"Home_search__mlrZV","loading":"Home_loading__1F5Hv","card":"Home_card__C-MbQ","info":"Home_info__1pYFf","arrow":"Home_arrow__hpqRN"};